import { render, staticRenderFns } from "./abnormalData.vue?vue&type=template&id=6b6bee33&scoped=true"
import script from "./abnormalData.vue?vue&type=script&lang=js"
export * from "./abnormalData.vue?vue&type=script&lang=js"
import style0 from "./abnormalData.vue?vue&type=style&index=0&id=6b6bee33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6bee33",
  null
  
)

export default component.exports